import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import GS from "@ts/GlobalSetting";
import PlanUnitCountResult from "@components/product/PlanUnitCountResult";
import { Product } from "./ProductTypes";
import Tools from "@ts/Tools";
import ApiProxy from "@ts/ApiProxy";
import CartCookie from "../shared/CartCookie";
import FormTools from "@root/ts/FormTools";
import schema from "@schema/product/send-form.json";
import PlanOption from "./PlanOption";
import { Cart } from "../cart/CartTypes";
import Nav from "../common/Nav";
import Popups from "../popups/Popups";

export default class PlanResult extends ComponentBase {
  isSubmitAble: boolean = false;
  cartRecord: Product.CartRecord;

  constructor(elem: ComponentElem) {
    super(elem);
    this.clearRecord();
    let pageData: Product.PageData = ApiProxy.getPageData();
    if (pageData.cart_record) {
      this.cartRecord.id = pageData.cart_record.id;
      this._updateAddToCartButton();
    }
    this.update();
    this.$root.find(`.btn-book-now`).on("click", (event: JQuery.ClickEvent) => {
      event.preventDefault();
      this.sendForm(true);
    });

    this.$root.find(".btn-add-to-cart").on("click", (event: JQuery.ClickEvent) => {
      event.preventDefault();
      this.sendForm(false);
    });
  }

  clearRecord() {
    this.cartRecord = { plan_data: {} };
    this._updateAddToCartButton();
  }

  private _updateAddToCartButton() {
    this.$root.attr("is-in-cart", this.cartRecord.id ? "true" : "false");
  }

  update(
    dateId?: string,
    dateText?: string,
    planOption?: PlanOption) {

    let planData: Product.PlanData,
      planTimeData: Product.TimeData,
      selectedUnitList: Product.SelectedUnitList;

    if (planOption) {
      planData = planOption.getData();
      planTimeData = planOption.getSelectedTime();
      selectedUnitList = planOption.getSelectedUnits();
    }

    this.$root.find('[data-field="date-text"]').text(dateText ? dateText : "-");
    this.$root.find('[data-area="plan"]').attr("is-plan-picked", planData ? "true" : "false");
    this.$root.find('[data-field="plan-name"]').text(planData ? planData.name : "-");
    this.$root.find('[data-field="plan-time"]').text(planTimeData ? planTimeData.time : "--:--");

    this.cartRecord.plan_data = {};
    this.cartRecord.plan_data.date = dateId;
    this.cartRecord.plan_data.plan_id = planData ? planData.id : "";
    this.cartRecord.plan_data.time_id = planTimeData ? planTimeData.id : "";
    this.cartRecord.plan_data.unit_data = [];

    let $unitCount = this.$root.find(`[data-field="unit-count"]`);
    let $unitCountArea = this.$root.find(`[data-area="order-number"]`);
    $unitCount.empty();

    let totalSum = 0;
    let thereIsCount = false;
    let submittable = false;

    if (planOption && planOption.totalCount > 0)
      submittable = true;

    if (selectedUnitList) {
      selectedUnitList.forEach((data: Product.UnitCountResult) => {
        if (data.count > 0) {
          let component = new PlanUnitCountResult(PlanUnitCountResult.createElem(), data);
          $unitCount.append(component.$root);
          totalSum += component.getSum();
          thereIsCount = true;
          this.cartRecord.plan_data.unit_data.push({ id: data.data.id, count: data.count });
        }
      });
    }

    if (!planTimeData)
      submittable = false;

    $unitCountArea.attr("is-empty", thereIsCount ? "false" : "true");

    let ezpoint = GS.priceToEzpoint(totalSum);

    this.$root.find('.sum-value').text(Tools.formatNumber(totalSum));
    this.$root.find('.ezpoint').text(ezpoint);

    let feedback = {
      planCompleted: true,
      dateCompleted: true
    };

    if (!dateText)
      feedback.dateCompleted = false;

    if (!planData || !planTimeData || !thereIsCount)
      feedback.planCompleted = false;

    this.isSubmitAble = submittable;
    this.$root.attr("submittable", this.isSubmitAble ? "true" : "false");

    return feedback;
  }

  getFormData() {
    return this.cartRecord;
  }

  sendForm(toReserveNow: boolean) {
    if (!ApiProxy.getCommonPageData().login_state.is_login) {
      Popups.to("login");
      return;
    }

    let apiName = "product/send-form";
    let formData = this.getFormData();
    let params = {
      to_reserve_now: toReserveNow,
      formData: formData
    };

    FormTools
      .sendForm(apiName, params, undefined, { schema: schema, exampleIndex: 0 })
      .then((result: { cart_id: string, next_url?: string }) => {
        let isUpdate = true;
        if (!this.cartRecord.id) {
          this.cartRecord.id = result.cart_id;
          this._updateAddToCartButton();
          isUpdate = false;
        }
        CartCookie.addOrUpdate(this.cartRecord as Cart.CartRecord);
        if (toReserveNow)
          FormTools.handleNextUrl(result);
        else
          Nav.showAddToCartHint(isUpdate);
      });
  }
}